<script setup lang="ts">
</script>

<template>
  <footer id="footer" class="container">
    <div class="footer-container">
      <div class="footer-caption">
        <span>Support</span>
      </div>
      <div class="footer-details">
        <p>We’ll be happy to help you with any questions or issues. Feel free to contact us:</p>
      </div>
      <div class="footer-contacts">
        <div class="footer-social-list">
          <a href="https://t.me/jstaking" class="social-item" target="_blank"><i-app-tg-logo /></a>
        </div>
      </div>
    </div>

    <div class="footer-copyright">
      <span>© 2021-{{ new Date().getFullYear() }} JStaking.  All rights reserved.</span>
    </div>
  </footer>
</template>

<style lang="scss">
footer {
  display: flex;
  flex-direction: column;
  background-color: transparent;

  &.container {
    margin-top: 60px;

    @media (max-width: $breakpoint-xs) {
      margin-top: 38px;
    }
  }

  .footer {
    &-container {
      border-radius: 10px;
      background-color: $gray-03;
      padding: 64px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      @media (max-width: $breakpoint-md) {
        padding: 36px;
      }
    }
    &-caption {
      font-size: 26px;
      font-weight: 700;
      text-transform: uppercase;
      margin-bottom: 36px;

      @media (max-width: $breakpoint-md) {
        margin-bottom: 28px;
      }
    }

    &-details {
      max-width: 540px;
      width: 100%;
      font-size: 24px;
      font-weight: 600;
      line-height: 30px;
      letter-spacing: 0.24px;
      margin-bottom: 60px;

      @media (max-width: $breakpoint-md) {
        font-size: 20px;
        line-height: 26px;
        letter-spacing: 0.2px;
        padding: 0 8px;
        margin-bottom: 40px;
      }

      p {
        margin: 0;
      }
    }

    &-social-list {
      display: flex;
      gap: 16px;

      .social-item {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-color: rgba($black, 0.08);
        display: grid;
        place-items: center;

        svg {
          margin-left: -4px;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }

    &-copyright {
      padding: 60px 0 24px;
      text-align: center;

      @media (max-width: $breakpoint-xs) {
        padding: 24px 0;
      }

      span {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.28px;
        color: $gray-01;
      }
    }
  }
}
</style>
